import axios from 'axios';
import * as XLSX from 'xlsx';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from 'primereact/confirmdialog';
import { Tag } from 'primereact/tag';
import { Skeleton } from 'primereact/skeleton';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { formatDate, formatedDate } from '../../Helper/constent';
import StockTransferPrint from '../PrintHelper/StockTransferPrint';
import { InputNumber } from 'primereact/inputnumber';

const StockTransferReport = () => {
    const { apiUrl, apiHeadersJson, store_id, user_id, auth_routes } = useContext(ConfigContext);
    const [rows, setRows] = useState([]);
    const [Status, setStatus] = useState(null);
    const [prStatus, setPrStatus] = useState(null);
    const [keyword, setKeyword] = useState(null);
    const [callApi, setCallApi] = useState(true);
    const toast = useRef(null);
    const [dataTableLoading, setDataTableLoading] = useState(true);
    const { limit, order } = useParams();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [rowsPerPage, setRowsPerPage] = useState(limit || 10);
    const [sortOrder, setSortOrder] = useState(order, 'DESC');

    const navigate = useNavigate();
    const headers = apiHeadersJson;
    const [permissions, setPermissions] = useState([]);

    /// print states
    const [dataLoading, setDataLoading] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [printProducts, setPrintProducts] = useState([]);
    const [user, setUser] = useState({});
    const [isReadyToPrint, setIsReadyToPrint] = useState(false);

    if (!limit || !order || !['ASC', 'DESC'].includes(order.toUpperCase())) {
        navigate('/StockTransferReports/30/DESC')
    }

    const GetList = async () => {
        setDataTableLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/GetStockTransferReport`, { params: { store_id, limit, order, keyword, action_status: Status === "All" ? '' : Status, purchase_status: prStatus === "All" ? '' : prStatus, start_date: startDate, end_date: endDate }, headers });
            const { success, data, message } = response.data;
            setCallApi(false);
            if (success) {
                setRows(data);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setDataTableLoading(false);
        }
    };

    const getInfo = async () => {
        try {
            const response = await axios.get(`${apiUrl}/User/GetUserInfo`, { params: { user_id }, headers });
            const { success, permissions, message } = response.data;

            if (success) {
                setPermissions(permissions);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        callApi && GetList();
    }, [callApi]);

    useEffect(() => {
        GetList();
    }, [limit, order]);

    useEffect(() => {
        getInfo();
        store_id && GetList();
    }, [store_id]);

    useEffect(() => {
        const timer = setTimeout(() => { keyword && GetList(); }, 1500);
        return () => clearTimeout(timer);
    }, [keyword]);

    const clearFilters = () => {
        setStartDate(null);
        setEndDate(null);
        setKeyword("");
        setStatus("");
        setPrStatus("");
        setCallApi(true)
    };
    const applyFilters = () => {
        GetList();
        setCallApi(true)
    };

    const confirmDelete = (inv_transfer_id, id) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Stock Transfer?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => DetetePurchaseProducts(inv_transfer_id, id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Delete operation cancelled', life: 3000 });
            }
        });
    };

    const confirmVerify = (id, store_id) => {
        confirmDialog({
            message: 'Are you sure you want to verify this purchase?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => VerifyPurchaseProducts(id, store_id),
            reject: () => {
                toast.current.show({ severity: 'info', summary: 'Cancelled', detail: 'Verify operation cancelled', life: 3000 });
            }
        });
    };

    const DetetePurchaseProducts = async (inv_transfer_id, id) => {
        try {
            const response = await axios.delete(`${apiUrl}/Management/DeleteStockTransfer`, { params: { inv_transfer_id, purchase_id: id }, headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const VerifyPurchaseProducts = async (id, store_id) => {
        try {
            const response = await axios.post(`${apiUrl}/Management/VerifyPurchaseProducts`, { purchase_id: id, store_id }, { headers });
            const { success, message } = response.data;
            if (success) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: message, life: 3000 });
                GetList();
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const handlePrint = async (id) => {
        try {
            await getPrintInfo(id);
            setIsReadyToPrint(true);
        } catch (error) {
            console.log('error', error);
            alert('error while printing');
        }
    };

    const getPrintInfo = async (id) => {
        setDataLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Reports/GetStockTransferInvoice`, { params: { inv_transfer_id: id, }, headers });
            const { success, data, prodcuts, user, message } = response.data;

            if (success) {
                setInvoiceData(data[0]);
                setPrintProducts(prodcuts);
                setUser(user[0]);
                if (prodcuts?.length === 0) {
                    alert('Sorry No Product Found Please Check The Bill');
                }
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.log('Error fetching invoice:', error);
            alert('error while fetching print data');
        } finally {
            setDataLoading(false);
        }
    };

    const performPrint = () => {
        const invoiceContainer = document.querySelector('.puechase-invoice-container');
        if (!invoiceContainer) {
            alert("Stock Transfer Invoice not found.");
            return;
        }

        const styles = Array.from(document.styleSheets)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules)
                        .map(rule => rule.cssText)
                        .join('\n');
                } catch (e) {
                    return '';
                }
            })
            .join('\n');

        const htmlContent = `
        <html>
            <head><style>${styles}</style></head>
            <body>${invoiceContainer.innerHTML}</body>
        </html>
    `;

        if (window.electronAPI) {
            window.electronAPI.silentPrint(htmlContent);
        } else {
            const printWindow = window.open('', '_blank');
            printWindow.document.write(htmlContent);
            printWindow.document.close();
            printWindow.focus();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 1000);
        }
    };

    useEffect(() => {
        if (isReadyToPrint && invoiceData && printProducts.length > 0 && user) {
            performPrint();
            setIsReadyToPrint(false);
        }
    }, [invoiceData, printProducts, user]);

    const paginatorLeft = <Button type="button" icon="pi pi-refresh" text onClick={GetList} />;

    const LinkBody = (data) => {
        return (
            data.invoice_number ?
                <NavLink to={`/ViewStockTransfer/${data.inv_transfer_id}/${data.purchase_id}`} className={'text-primary'} style={{ cursor: 'pointer', textDecoration: 'none' }}>{data.invoice_number}</NavLink>
                :
                <NavLink to={`/ViewStockTransfer/${data.inv_transfer_id}/${data.purchase_id}`} className={'text-primary'} style={{ cursor: 'pointer', textDecoration: 'none' }}>{"View Purchase"}</NavLink>
        );
    };

    const ActionBody = (data) => {
        const GetActionStatusById = (info) => {
            let value = info.action_type == 1 ? 'Edited' : info.action_type == 2 ? 'Deleted' : '';
            let severity = info.action_type == 1 ? 'info' : info.action_type == 2 ? 'danger' : '';
            return { value, severity };
        };

        const CheckShowBtns = (info) => {
            const edit = info.purchase_status == 0 && info.action_type != 2;
            const verify = info.purchase_status == 0 && info.action_type != 2;
            const deleteBtn = info.purchase_status == 0 && info.action_type != 2;
            const print = info.action_type == 2;
            return { edit, verify, deleteBtn, print };
        };

        return (
            <>
                {data.action_type != 0 && (
                    <Tag severity={GetActionStatusById(data).severity} value={GetActionStatusById(data).value}></Tag>
                )}
                <div className="ms-2 btn-group" role="group" aria-label="Action Buttons">
                    {/* Edit Button */}
                    {CheckShowBtns(data).edit && (
                        <NavLink to={`/StockTransfer/${data.purchase_id}/${data.inv_transfer_id}`} className="btn btn-primary">
                            <i className="pi pi-pen-to-square"></i>
                        </NavLink>
                    )}
                    {/* Print Button */}
                    {!CheckShowBtns(data).print && auth_routes.includes('StockTransferInvoice') &&
                        <button disabled={dataLoading} onClick={() => handlePrint(data?.inv_transfer_id)} type='button' className="btn btn-info text-white">
                            {dataLoading ? (
                                <i className="pi pi-spin pi-spinner"></i>
                            ) : (
                                <i className="pi pi-print"></i>
                            )}
                        </button>}
                    {/* Verify Button */}
                    {CheckShowBtns(data).verify && (
                        <button
                            className="btn btn-success"
                            onClick={() => confirmVerify(data.purchase_id, data.store_id)}
                        >
                            <i className="pi pi-check-square"></i>
                        </button>
                    )}
                    {/* Delete Button */}
                    {CheckShowBtns(data).deleteBtn && (
                        <button
                            className="btn btn-danger"
                            onClick={() => confirmDelete(data.inv_transfer_id, data.purchase_id)}
                        >
                            <i className="pi pi-trash"></i>
                        </button>
                    )}
                </div>
            </>
        );
    };


    return (
        <div className="container-fluid">
            <Toast ref={toast} />
            <div className="d-flex justify-content-between align-items-center mt-4">
                <div className="main-heading">
                    <h6>Stock Transfer</h6>
                </div>
                <div className="main-heading-right">
                    <h6>Reports/Stock Transfer</h6>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 mt-4">
                    <div className="card">
                        <div className="rounded-top px-3 py-2 bg-dark d-flex flex-wrap justify-content-between align-items-center">
                            <h4 className="text-white">Stock Transfer</h4>
                        </div>
                        <div className='card-header'>
                            <div className="row">
                                <div className="col-md-3">
                                    <input
                                        type="date"
                                        className="form-control h-100"
                                        onChange={(e) => setStartDate(e.target.value)}
                                        value={startDate || ''}
                                        placeholder="Start date"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <input
                                        type="date"
                                        className="form-control h-100"
                                        onChange={(e) => setEndDate(e.target.value)}
                                        value={endDate || ''}
                                        placeholder="End date"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <select
                                        className="form-select h-100"
                                        value={prStatus || ""}
                                        onChange={(e) => setPrStatus(e.target.value)}>
                                        <option value="" disabled>Select a Status</option>
                                        <option value={null}>All</option>
                                        <option value="0">Pending</option>
                                        <option value="1">Verified</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <select
                                        className="form-select h-100"
                                        value={Status || ""}
                                        onChange={(e) => setStatus(e.target.value)}>
                                        <option value="" disabled>Select Action Status</option>
                                        <option value={null}>All</option>
                                        <option value="0">Created</option>
                                        <option value="1">Edited</option>
                                        <option value="2">Deleted</option>
                                    </select>
                                </div>
                            </div>

                            <div className="float-end my-3">
                                <div className="d-flex justify-content-center align-items-between">
                                    <Button label="Filter"
                                        disabled={!keyword && !startDate && !endDate && !Status && !prStatus}
                                        icon="pi pi-filter" className="ms-3" onClick={applyFilters} />
                                    <Button
                                        disabled={!keyword && !startDate && !endDate && !Status && !prStatus}
                                        label="Clear" icon="pi pi-times" severity='secondary' className="ms-3" onClick={clearFilters} />
                                </div>
                            </div>
                            <div className="mt-3 col-md-9"></div>
                            <div className="mt-3 col-md-3">
                                <IconField iconPosition="left" className='w-100'>
                                    <InputIcon className="pi pi-search"> </InputIcon>
                                    <InputText
                                        onChange={(e) => setKeyword(e.target.value)}
                                        value={keyword}
                                        className='w-100'
                                        placeholder="Search..."
                                    />
                                </IconField>
                            </div>
                        </div>
                        {dataTableLoading ? (
                            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
                                <Skeleton shape="rectangle" width="100%" height="40px" className="mb-1" />
                            ))
                        ) : (
                            <>
                                <div className="d-flex flex-wrap justify-content-between align-items-center">
                                    <div className="d-flex align-items-center p-3">
                                        <span className="me-2">Show:</span>
                                        <InputNumber
                                            value={rowsPerPage}
                                            onChange={(e) => setRowsPerPage(e.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    navigate(`/StockTransferReports/${rowsPerPage}/${sortOrder}`)
                                                }
                                            }}
                                            mode="decimal"
                                            showButtons
                                            min={1}
                                            step={10}
                                            className="me-3"
                                        />
                                        <span className="me-2">entries</span>
                                    </div>
                                    <div className="d-flex align-items-center p-3">
                                        <span className="me-2">Sort Order:</span>
                                        <select
                                            className="form-select"
                                            value={sortOrder}
                                            onChange={(e) => { setSortOrder(e.target.value); navigate(`/StockTransferReports/${rowsPerPage}/${e.target.value}`) }}
                                            style={{ width: '100px' }}
                                        >
                                            <option value="ASC">Ascending</option>
                                            <option value="DESC">Descending</option>
                                        </select>
                                    </div>
                                </div>
                                <DataTable
                                    value={rows}
                                    paginator
                                    rows={rowsPerPage}
                                    paginatorTemplate="CurrentPageReport PaginatorLeft"
                                    currentPageReportTemplate="Total Records: {totalRecords}"
                                    paginatorLeft={paginatorLeft}
                                    paginatorRight={<></>}
                                    sortOrder={sortOrder === 'ASC' ? 1 : -1}>

                                    <Column field="to_store_name" header="To Store" sortable />
                                    <Column field={LinkBody} header="Invoice Number" />
                                    <Column body={(data) => formatedDate(data?.inv_transfer_date)} header="Date" />
                                    <Column field="user_name" header="Verified By" />
                                    <Column header="Status" body={(data) => (data.purchase_status === '1' ? <Tag severity="success" value="Verified" /> : <Tag severity="warning" value="Pending" />)} />
                                    {permissions.includes('PurchaseAmount') && <Column field="grand_total_amount" header="Total Amount" />}
                                    <Column body={ActionBody} header="Action" />
                                </DataTable>
                            </>
                        )}
                    </div>
                    <div className="mb-5"></div>
                </div>
            </div>
            <StockTransferPrint purchaseDetails={invoiceData} products={printProducts} user={user} isShow={false} />
        </div>
    );
};

export default StockTransferReport;